import { __awaiter } from "tslib";
import withSessionCacheRequest from '../decorators/withSessionCacheRequest';
import { API_CACHE_KEYS } from '../utils/cache/cacheStore';
import AjaxUtils from './ajaxUtils';
const COMMUNITY_STATUS_CACHE_TTL_SECONDS = 300;
const fetchCommunityStatus = (query = '') => withSessionCacheRequest(`${API_CACHE_KEYS.FETCH_COMMUNITY_STATUS_CACHE_KEY}_${query}`, COMMUNITY_STATUS_CACHE_TTL_SECONDS, () => AjaxUtils.get(`${envConfig.PLATFORM_SERVER_URL}/v2/community/status?${query}`, true));
const fetchOutlookDesktopConnectionSettings = () => AjaxUtils.get(`${envConfig.PLATFORM_SERVER_URL}/api/v1/outlook-settings`, true);
const fetchCommunitySettings = (userId) => __awaiter(void 0, void 0, void 0, function* () {
    return withSessionCacheRequest(`${API_CACHE_KEYS.FETCH_COMMUNITY_SETTINGS_CACHE_KEY}_${userId}`, COMMUNITY_STATUS_CACHE_TTL_SECONDS, () => AjaxUtils.get(`${envConfig.PLATFORM_SERVER_URL}/api/v2/community/settings?$eager=[analytics]`, true));
});
const updateCommunityAnalytics = data => {
    try {
        return AjaxUtils.patch(`${envConfig.PLATFORM_SERVER_URL}/api/v2/community/analytics`, data, true);
    }
    catch (e) {
        return undefined;
    }
};
export { fetchCommunitySettings, fetchCommunityStatus, fetchOutlookDesktopConnectionSettings, updateCommunityAnalytics };
